import React, { useContext } from 'react'
import { css, useTheme } from '@emotion/react'
import { base, padding, hover } from '../emotion/anchor-css'
import AppContext from '../context/app'
import NavLinks from './nav-links'
import BrandLogoLink from './brand-logo-link'
import SearchButton from '../algolia/search-button'
import Container from 'react-bootstrap/Container'
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import accountIconWhite from '../svgs/account-icon-white.svg'
import contactSupportIconWhite from '../svgs/contact-support-icon-white.svg'
import Cart from './cart'

const container = css({
    gap: 20,
    '@media(min-width: 1200px)': {
        gap: 56
    },
})

export const scale = css({
    transition: 'transform .1s ease-in',
    '&:hover': {
        transform: 'scale(1.1)'
    }
})

const support = theme => css({
    fontFamily: theme.fonts.primaryHeavy,
    transition: 'transform .1s',
    '&:hover': {
        transform: 'scale(1.05)',
    }
})

export default function Navbar() {
    const { setShowBlurOverlay, screenWidth } = useContext(AppContext)
    const theme = useTheme()

    return (
        <nav
            className='sticky-top'
            css={{
                backgroundColor: 'rgba(0, 0, 0, 0.8)',
                backdropFilter: 'blur(10px)',
                [theme.queries.lg]: {
                    backgroundColor: 'rgba(0, 0, 0, 1)',
                    backdropFilter: 'none',
                }
            }}
        >
            <Container className='d-flex justify-content-between align-items-center'>
                <BrandLogoLink
                    onMouseEnter={() => setShowBlurOverlay('')}
                    className='d-inline-block'
                    style={{
                        paddingTop: 24,
                        paddingBottom: 24
                    }}
                />

                <div className='d-xxl-flex d-none' css={container}>
                    <NavLinks emotion={theme => [base, padding, hover(theme)]} />
                </div>

                <div className='d-flex align-items-center' style={{ gap: 35 }}>
                    {/* SUPPORT */}
                    <a
                        href="https://support.alesis.com/"
                        target='_blank'
                        rel='noreferrer'
                        css={[base, support]}
                        onMouseEnter={() => setShowBlurOverlay('')}
                    >
                        {screenWidth < 992 ? <img src={contactSupportIconWhite} alt='' /> : 'SUPPORT'}
                    </a>

                    {/* SEARCH */}
                    <SearchButton />

                    {/* ACCOUNT */}
                    <a
                        href="https://profile.inmusicbrands.com/customer/account/login/"
                        target='_blank'
                        rel='noreferrer'
                        css={scale}
                    >
                        <img src={accountIconWhite} alt='' />
                    </a>

                    <Cart />
                </div>
            </Container>
        </nav>
    )
}
